import { render, staticRenderFns } from "./ScheduleVacations.vue?vue&type=template&id=8207bb24"
import script from "./ScheduleVacations.vue?vue&type=script&lang=js"
export * from "./ScheduleVacations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports